/*
  WSP cart tools
  1. Delivery check: customer enters a postcode in the cart and sees the delivery price and lead time.
     Prices come from Shopify's own shipping rates (Settings > Shipping and delivery), so they always
     match what checkout charges. Change the rates there, not here.
  2. Request A Quote for the cart: sends everything in the cart (items, options, prices, delivery,
     a link that rebuilds the cart) to the HubSpot form "Website enquiry - Request A Quote".
  Mounted automatically into the cart page summary and the cart drawer. Loaded from snippets/doc-head-core.liquid.
*/
(function () {
  if (window.WSPCartTools) return;

  var PORTAL = '139857493';
  var FORM = '5ea627bf-63ec-49fc-ae6b-34187853b495';
  var ENDPOINT = 'https://api-eu1.hsforms.com/submissions/v3/integration/submit/' + PORTAL + '/' + FORM;
  var PHONE = '01371 831731';
  var KEY = 'wsp_delivery_postcode';
  var SCOTLAND = ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'TD', 'ZE'];
  var OFFSHORE = { IM: 'the Isle of Man', GY: 'Guernsey', JE: 'Jersey' };

  var state = { delivery: null };

  function saved(v) {
    try {
      if (v === undefined) return localStorage.getItem(KEY) || '';
      localStorage.setItem(KEY, v);
    } catch (e) { return ''; }
  }
  function money(n) {
    return Number(n).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cartRoute() {
    return (window.theme && theme.routes && theme.routes.cart) || '/cart';
  }
  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  // UK postcode -> formatted postcode + Shopify province (zones are England & Wales / Scotland / Northern Ireland)
  function parsePostcode(raw) {
    var s = (raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    var m = s.match(/^([A-Z]{1,2})(\d[A-Z\d]?)(\d[A-Z]{2})$/);
    if (!m) return null;
    var area = m[1], district = m[2];
    var pc = area + district + ' ' + m[3];
    if (OFFSHORE[area]) return { pc: pc, offshore: OFFSHORE[area] };
    var province = 'England';
    if (area === 'BT') province = 'Northern Ireland';
    else if (SCOTLAND.indexOf(area) > -1 && !(area === 'TD' && district === '15')) province = 'Scotland';
    return { pc: pc, province: province };
  }

  function fetchRates(info) {
    var q = 'shipping_address[zip]=' + encodeURIComponent(info.pc) +
      '&shipping_address[country]=' + encodeURIComponent('United Kingdom') +
      '&shipping_address[province]=' + encodeURIComponent(info.province);
    return fetch(cartRoute() + '/shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw d;
          return d.shipping_rates || [];
        });
      });
  }

  function noOnlinePrice(where) {
    return '<p>We can\'t price delivery to ' + esc(where) + ' online. Call <a href="tel:01371831731">' + PHONE +
      '</a> or use Request A Quote and we\'ll include it.</p>';
  }

  /* ---------- Delivery check ---------- */
  if (!customElements.get('wsp-delivery-check')) {
    customElements.define('wsp-delivery-check', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.compact = this.hasAttribute('data-compact');
        var id = 'wsp-dc-' + Math.random().toString(36).slice(2, 8);
        this.innerHTML =
          (this.compact
            ? '<button type="button" class="link text-sm wsp-dc__toggle">Check delivery cost</button>'
            : '<label class="wsp-dc__label" for="' + id + '">Delivery to your site</label>') +
          '<div class="wsp-dc__row"' + (this.compact ? ' hidden' : '') + '>' +
          '<input id="' + id + '" type="text" class="input wsp-dc__input" placeholder="Enter postcode" autocomplete="postal-code" autocapitalize="characters" maxlength="10"' +
          (this.compact ? ' aria-label="Delivery postcode"' : '') + '>' +
          '<button type="button" class="btn btn--secondary wsp-dc__btn">Check</button>' +
          '</div>' +
          '<div class="wsp-dc__result" aria-live="polite" hidden></div>';

        this.input = this.querySelector('.wsp-dc__input');
        this.btn = this.querySelector('.wsp-dc__btn');
        this.row = this.querySelector('.wsp-dc__row');
        this.result = this.querySelector('.wsp-dc__result');
        this.toggle = this.querySelector('.wsp-dc__toggle');

        var self = this;
        this.btn.addEventListener('click', function () { self.check(); });
        this.input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); self.check(); }
        });
        if (this.toggle) this.toggle.addEventListener('click', function () { self.open(); });
        this.result.addEventListener('click', function (e) {
          if (e.target.closest('.wsp-dc__change')) { e.preventDefault(); self.open(); }
        });

        var pc = saved();
        if (pc) { this.input.value = pc; this.check(true); }
      }

      open() {
        this.row.hidden = false;
        if (this.toggle) this.toggle.hidden = true;
        this.input.focus();
      }

      show(html) {
        this.result.innerHTML = html;
        this.result.hidden = false;
      }

      check(silent) {
        var info = parsePostcode(this.input.value);
        if (!info) {
          if (!silent) this.show('<p class="wsp-dc__err">Please enter a full UK postcode, e.g. SW1A 1AA.</p>');
          return;
        }
        this.input.value = info.pc;
        saved(info.pc);
        var self = this;

        if (info.offshore) {
          state.delivery = { postcode: info.pc, text: 'No online price (' + info.offshore + ')' };
          this.done(noOnlinePrice(info.offshore));
          return;
        }

        this.btn.disabled = true;
        this.btn.classList.add('is-loading');
        fetchRates(info).then(function (rates) {
          if (!rates.length) {
            state.delivery = { postcode: info.pc, text: 'No online price' };
            self.done(noOnlinePrice(info.pc));
            return;
          }
          state.delivery = {
            postcode: info.pc,
            text: rates.map(function (r) { return money(r.price) + ' ex VAT, ' + r.name; }).join('; ')
          };
          var html = rates.map(function (r) {
            return '<p><span class="wsp-dc__price">' + money(r.price) + ' ex VAT</span> delivery to ' + esc(info.pc) +
              '</p><p class="wsp-dc__note">' + esc(r.name) + '</p>';
          }).join('');
          self.done(html);
        }).catch(function () {
          state.delivery = null;
          self.done('<p class="wsp-dc__err">We couldn\'t get a delivery price just now. Call <a href="tel:01371831731">' + PHONE + '</a>.</p>');
        }).finally(function () {
          self.btn.disabled = false;
          self.btn.classList.remove('is-loading');
        });
      }

      done(html) {
        if (this.compact) {
          this.row.hidden = true;
          if (this.toggle) this.toggle.hidden = true;
          html += '<p><a href="#" class="link wsp-dc__change">Change postcode</a></p>';
        }
        this.show(html);
        document.querySelectorAll('wsp-cart-quote').forEach(function (q) { q.prefillPostcode(); });
      }
    });
  }

  /* ---------- Request A Quote for the cart ---------- */
  function interest(items) {
    var top = items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; })[0];
    var t = top ? (top.product_title + ' ' + (top.vendor || '')).toLowerCase() : '';
    if (/gate|barrier/.test(t)) return 'Security Gates';
    if (/fenc|mesh/.test(t)) return 'Fencing';
    if (/powerbox|solar/.test(t)) return 'Solar PowerBox';
    if (/pal |access|gsm|intercom|keypad|remote|detector|wiegand/.test(t)) return 'Access Control';
    return 'Other';
  }

  function cartSummary(cart, delivery, notes) {
    var lines = ['Quote request from the website cart', 'Form: Cart quote', '', 'Items:'];
    cart.items.forEach(function (i) {
      var line = '- ' + i.quantity + ' x ' + i.product_title;
      if (i.variant_title) line += ' (' + i.variant_title + ')';
      if (i.sku) line += ' [SKU ' + i.sku + ']';
      line += ' @ ' + money(i.final_price / 100) + ' = ' + money(i.final_line_price / 100) + ' ex VAT';
      lines.push(line);
      if (i.properties) {
        Object.keys(i.properties).forEach(function (k) {
          var v = i.properties[k];
          if (k.charAt(0) !== '_' && v) lines.push('    ' + k + ': ' + v);
        });
      }
    });
    lines.push('Cart subtotal: ' + money(cart.total_price / 100) + ' ex VAT');
    if (cart.total_discount) lines.push('Includes savings of ' + money(cart.total_discount / 100));
    if (delivery) lines.push('Delivery to ' + delivery.postcode + ': ' + delivery.text);
    lines.push('Rebuild this cart: ' + location.origin + '/cart/' +
      cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(','));
    if (notes) lines.push('', 'Message:', notes);
    return lines.join('\n');
  }

  function post(fields) {
    var context = { pageUri: location.href, pageName: 'Cart - Request A Quote' };
    var hutk = cookie('hubspotutk');
    if (hutk) context.hutk = hutk;
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ submittedAt: Date.now(), fields: fields, context: context })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r; });
  }

  if (!customElements.get('wsp-cart-quote')) {
    customElements.define('wsp-cart-quote', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.id = 'cart-quote';
        var f = function (key, label, type, req, extra) {
          return '<div class="wsp-cq__field"><label for="wsp-cq-' + key + '">' + label + (req ? ' *' : '') + '</label>' +
            '<input id="wsp-cq-' + key + '" data-key="' + key + '" type="' + type + '" class="input"' + (extra || '') + '></div>';
        };
        this.innerHTML =
          '<h2 class="h6 wsp-cq__title">Need a written quote for this order?</h2>' +
          '<p class="wsp-cq__intro">For a purchase order, account terms or sign-off. We\'ll email a quote for exactly what\'s in your cart, including delivery. Need a <a href="/pages/mesh-gates">matching gate</a>? Add it in the notes and we\'ll quote fence and gate together. Your cart stays saved.</p>' +
          '<button type="button" class="btn btn--secondary w-full wsp-cq__open">Request A Quote</button>' +
          '<div class="wsp-cq__form" hidden>' +
          '<div class="wsp-cq__grid">' +
          f('name', 'Name', 'text', true, ' autocomplete="name"') +
          f('company', 'Company', 'text', false, ' autocomplete="organization"') +
          f('email', 'Email', 'email', true, ' autocomplete="email"') +
          f('phone', 'Phone', 'tel', true, ' autocomplete="tel"') +
          '</div>' +
          f('postcode', 'Site postcode', 'text', false, ' autocomplete="postal-code" autocapitalize="characters" maxlength="10"') +
          '<div class="wsp-cq__field"><label for="wsp-cq-notes">Anything else? (optional)</label>' +
          '<textarea id="wsp-cq-notes" data-key="notes" class="input" rows="3" placeholder="e.g. need a matching gate, installation, delivery date"></textarea></div>' +
          '<button type="button" class="btn btn--primary w-full wsp-cq__send">Send quote request</button>' +
          '<p class="wsp-cq__error" role="alert" hidden></p>' +
          '<p class="wsp-cq__alt">Or call <a href="tel:01371831731">' + PHONE + '</a></p>' +
          '</div>' +
          '<div class="wsp-cq__done" role="status" hidden></div>';

        var self = this;
        this.querySelector('.wsp-cq__open').addEventListener('click', function () { self.open(); });
        this.querySelector('.wsp-cq__send').addEventListener('click', function () { self.send(); });
        this.querySelectorAll('input').forEach(function (el) {
          el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.send(); } });
        });
        if (location.hash === '#cart-quote') {
          setTimeout(function () { self.open(); self.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
        }
      }

      val(key) {
        var el = this.querySelector('[data-key="' + key + '"]');
        return el ? el.value.trim() : '';
      }

      prefillPostcode() {
        var el = this.querySelector('[data-key="postcode"]');
        var pc = saved();
        if (el && !el.value && pc) el.value = pc;
      }

      open() {
        this.querySelector('.wsp-cq__open').hidden = true;
        this.querySelector('.wsp-cq__form').hidden = false;
        this.prefillPostcode();
        this.querySelector('[data-key="name"]').focus({ preventScroll: true });
      }

      error(msg) {
        var el = this.querySelector('.wsp-cq__error');
        el.textContent = msg;
        el.hidden = !msg;
      }

      send() {
        var name = this.val('name'), email = this.val('email'), phone = this.val('phone');
        if (!name) return this.error('Please add your name.');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.error('Please add a valid email address.');
        if (phone.replace(/\D/g, '').length < 7) return this.error('Please add a phone number.');
        this.error('');

        var self = this;
        var btn = this.querySelector('.wsp-cq__send');
        btn.disabled = true;
        btn.classList.add('is-loading');

        var pcInfo = parsePostcode(this.val('postcode'));
        var pc = pcInfo ? pcInfo.pc : this.val('postcode').toUpperCase();
        var parts = name.split(/\s+/);

        // Make sure the delivery line matches the postcode given here
        var deliveryReady = Promise.resolve(state.delivery && state.delivery.postcode === pc ? state.delivery : null);
        if (pcInfo && !pcInfo.offshore && !(state.delivery && state.delivery.postcode === pc)) {
          deliveryReady = fetchRates(pcInfo).then(function (rates) {
            return rates.length ? {
              postcode: pc,
              text: rates.map(function (r) { return money(r.price) + ' ex VAT, ' + r.name; }).join('; ')
            } : null;
          }).catch(function () { return null; });
        }

        Promise.all([fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), deliveryReady])
          .then(function (res) {
            var cart = res[0];
            if (!cart.items || !cart.items.length) throw new Error('empty');
            var message = cartSummary(cart, res[1], self.val('notes'));
            if (pc) message = 'Site postcode: ' + pc + '\n' + message;
            var base = [
              { name: 'email', value: email },
              { name: 'firstname', value: parts.shift() || '' },
              { name: 'lastname', value: parts.join(' ') },
              { name: 'phone', value: phone },
              { name: 'message', value: message }
            ];
            var full = base.concat([
              { name: 'company', value: self.val('company') },
              { name: 'zip', value: pc },
              { name: 'product_interest', value: interest(cart.items) }
            ]);
            // If HubSpot rejects an optional field, send the core fields so the request still lands
            return post(full).catch(function () { return post(base); }).then(function () { return cart; });
          })
          .then(function (cart) {
            var done = self.querySelector('.wsp-cq__done');
            done.innerHTML = '<p class="wsp-cq__done-title">Thanks, your quote request has been sent.</p>' +
              '<p>We\'ll email a written quote to ' + esc(email) + '. Your cart is still saved if you\'d rather order online.</p>';
            self.querySelector('.wsp-cq__form').hidden = true;
            self.querySelector('.wsp-cq__intro').hidden = true;
            done.hidden = false;
            try {
              if (window.gtag) gtag('event', 'generate_lead', { currency: 'GBP', value: cart.total_price / 100, lead_source: 'cart_quote' });
            } catch (e) {}
          })
          .catch(function () {
            self.error('Sorry, that didn\'t send. Please call ' + PHONE + ' and we\'ll quote over the phone.');
          })
          .finally(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          });
      }
    });
  }

  /* ---------- Mount into the cart page and cart drawer ---------- */
  function mount() {
    // Cart page: delivery check above the subtotal, quote panel below the order summary
    var summary = document.getElementById('cart-summary');
    if (summary) {
      if (!summary.querySelector('wsp-delivery-check')) {
        var dc = document.createElement('wsp-delivery-check');
        dc.className = 'wsp-dc block mt-6';
        var subtotal = summary.querySelector('.flex.justify-between.items-center.mt-6');
        if (subtotal) subtotal.parentNode.insertBefore(dc, subtotal); else summary.appendChild(dc);
      }
      if (!document.querySelector('wsp-cart-quote') && document.querySelector('cart-items:not([data-empty="true"]) .cart-item')) {
        var cq = document.createElement('wsp-cart-quote');
        cq.className = 'wsp-cq block';
        summary.parentNode.insertBefore(cq, summary.nextSibling);
      }
    }

    // Cart drawer: compact delivery check + link to the quote form on the cart page
    var drawerTop = document.querySelector('#cart-drawer .cart-drawer_summary--non-stick');
    if (drawerTop && !drawerTop.querySelector('.wsp-drawer-tools')) {
      var wrap = document.createElement('div');
      wrap.className = 'wsp-drawer-tools w-full mb-4';
      wrap.innerHTML = '<wsp-delivery-check class="wsp-dc wsp-dc--compact block" data-compact></wsp-delivery-check>' +
        '<a href="' + cartRoute() + '#cart-quote" class="link text-sm wsp-drawer-tools__quote">Request A Quote for this cart</a>';
      drawerTop.appendChild(wrap);
    }
  }

  var queued = false;
  function queueMount() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; mount(); });
  }

  function init() {
    mount();
    new MutationObserver(queueMount).observe(document.body, { childList: true, subtree: true });
  }

  window.WSPCartTools = { parsePostcode: parsePostcode, state: state };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
